import { createFileRoute } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { useQuery, useMutation } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import {
  getAllPosts,
  getHomeLayout,
  saveHomeLayout,
} from "@/lib/posts.functions";

export const Route = createFileRoute("/admin/home")({
  component: AdminHome,
});

const SLOTS = 7; // 0 = öne çıkan, 1..6 = altındaki ızgara

function AdminHome() {
  const fetchAll = useServerFn(getAllPosts);
  const fetchLayout = useServerFn(getHomeLayout);
  const save = useServerFn(saveHomeLayout);

  const { data: posts } = useQuery({
    queryKey: ["admin-home-all-posts"],
    queryFn: () => fetchAll({ data: { lang: "tr" } }),
  });
  const { data: layout, refetch } = useQuery({
    queryKey: ["admin-home-layout"],
    queryFn: () => fetchLayout(),
  });

  const [slots, setSlots] = useState<string[]>(() => Array(SLOTS).fill(""));
  const [savedAt, setSavedAt] = useState<string | null>(null);

  useEffect(() => {
    if (!layout) return;
    const next = Array(SLOTS).fill("");
    for (const row of layout) {
      if (row.position >= 0 && row.position < SLOTS) next[row.position] = row.slug;
    }
    setSlots(next);
  }, [layout]);

  const saveMut = useMutation({
    mutationFn: () => save({ data: { slugs: slots } }),
    onSuccess: async () => {
      setSavedAt(new Date().toLocaleTimeString("tr-TR"));
      await refetch();
    },
    onError: (e: Error) => alert("Kaydetme başarısız: " + e.message),
  });

  const clearAll = () => {
    if (!confirm("Tüm seçimler temizlensin mi? (Otomatik sıralamaya döner)")) return;
    setSlots(Array(SLOTS).fill(""));
  };

  const setSlot = (i: number, slug: string) => {
    setSlots((prev) => {
      const next = [...prev];
      next[i] = slug;
      return next;
    });
  };

  const options = posts ?? [];

  return (
    <div className="space-y-8">
      <div>
        <h1 className="font-serif text-3xl">Ana sayfa düzeni</h1>
        <p className="text-sm text-ink/85 mt-2 max-w-2xl">
          Ana sayfadaki öne çıkan yazıyı ve altındaki 6 yazıyı buradan seçin.
          Tüm slotlar boş bırakılırsa otomatik (en yeni) sıralama kullanılır.
          Aynı yazıyı iki slota koymayın.
        </p>
      </div>

      <div className="space-y-4">
        {slots.map((slug, i) => (
          <div key={i} className="flex items-center gap-4">
            <span className="w-32 shrink-0 text-xs uppercase tracking-[0.2em] text-ink/85">
              {i === 0 ? "Öne çıkan" : `Slot ${i}`}
            </span>
            <select
              value={slug}
              onChange={(e) => setSlot(i, e.target.value)}
              className="flex-1 border border-ink/20 rounded px-3 py-2 text-sm bg-paper"
            >
              <option value="">— Seçilmedi —</option>
              {options.map((p) => (
                <option key={p.slug} value={p.slug}>
                  {p.title} ({p.slug})
                </option>
              ))}
            </select>
            {slug && (
              <button
                onClick={() => setSlot(i, "")}
                className="text-xs text-ink/60 hover:text-clay"
              >
                Temizle
              </button>
            )}
          </div>
        ))}
      </div>

      <div className="flex items-center gap-4 pt-4 border-t border-border">
        <button
          onClick={() => saveMut.mutate()}
          disabled={saveMut.isPending}
          className="px-5 py-2 bg-ink text-paper rounded-full text-xs uppercase tracking-[0.2em] disabled:opacity-50"
        >
          {saveMut.isPending ? "Kaydediliyor..." : "Kaydet"}
        </button>
        <button
          onClick={clearAll}
          className="text-xs text-ink/60 hover:text-clay underline"
        >
          Tüm seçimleri temizle
        </button>
        {savedAt && (
          <span className="text-xs text-moss">Kaydedildi · {savedAt}</span>
        )}
      </div>
    </div>
  );
}
